import { gql } from '@apollo/client';

export const SIMULATION = gql`
  query GetSimulation(
    $contractorId: Int!
    $date: String!
    $productCategoryShortname: String!
    $validityCategoryShortname: String!
    $participants: [ParticipantInput!]
    $productCategoryVisible: Boolean!
    $validityCategoryVisible: Boolean!
    $catalogSelectable: Boolean!
    $context: RequestContext!
  ) {
    simulation(
      contractorId: $contractorId
      date: $date
      productCategoryShortname: $productCategoryShortname
      validityCategoryShortname: $validityCategoryShortname
      participants: $participants
      productCategoryVisible: $productCategoryVisible
      validityCategoryVisible: $validityCategoryVisible
      catalogSelectable: $catalogSelectable
      context: $context
    ) {
      prices {
        publicTotal
        total
      }
      orderItems {
        participantId
        maxPublicPrice
        total
        type
        variant {
          id
          sku
        }
        children {
          maxPublicPrice
          total
          type
          slug
          variant {
            id
            sku
          }
        }
      }
      promotions {
        id
        name
        description
      }
      currency
      availableOptions {
        slug
        shortname
        description
        mandatory
        name
        priceFrom
        type
        isBooking
        bookingDays
        tags
      }
      availableUpsellings {
        productSlug
        title
        description
        priceDifference
        hidePriceDifference
        updatedFirstSkidate
        image
        validityCategoryValue
        productCategoryShortname
        validityCategoryShortname
      }
    }
  }
`;

export const PRODUCTCATEGORY = gql`
  query GetProductCategory(
    $productCategoryShortname: String!
    $validityCategoryId: Int
    $context: RequestContext!
  ) {
    productCategory(
      productCategoryShortname: $productCategoryShortname
      validityCategoryId: $validityCategoryId
      context: $context
    ) {
      id
      name
      shortname
      visible
      validFrom
      validTo
      validities {
        id
        name
        position
        shortname
        value
        visible
      }
      additionalInfo {
        description
        numBlackSlopes
        numBlueSlopes
        numGreenSlopes
        numKmSlope
        numRedSlopes
        numSkiLift
        numTotalSlopes
        tagline
        image
        ctaBlockTitle
        ctaBlockSubtitle
        ctaButtonLabel
      }
    }
  }
`;

export const PRODUCTCATEGORY_BY_ID = gql`
  query GetProductCategoryById(
    $productCategoryId: Int!
    $validityCategoryId: Int
    $context: RequestContext!
  ) {
    productCategoryById(
      productCategoryId: $productCategoryId
      validityCategoryId: $validityCategoryId
      context: $context
    ) {
      id
      name
      shortname
      visible
      validFrom
      validTo
      validities {
        id
        name
        position
        shortname
        value
        visible
      }
      additionalInfo {
        description
        numBlackSlopes
        numBlueSlopes
        numGreenSlopes
        numKmSlope
        numRedSlopes
        numSkiLift
        numTotalSlopes
        tagline
        image
        ctaBlockTitle
        ctaBlockSubtitle
        ctaButtonLabel
      }
    }
  }
`;

export const PRODUCT = gql`
  query GetProducts($productCategoryShortname: String!, $context: RequestContext!) {
    products(productCategoryShortname: $productCategoryShortname, context: $context) {
      id
      calendarDisplay
      slug
      name
      protectedByCode
      isBooking
      bookingDays
      exclusionPeriods {
        startDate
        endDate
      }
      consumerCategories {
        ageMax
        ageMin
        name
        shortname
        student
        visible
        position
      }
      additionalInfo {
        shortDescription
      }
      hasDynamicPricing
      includedOptions
      catalog {
        contractor
        selectable
      }
      firstSellableDate
      lastSellableDate
      validityCategory {
        id
        shortname
        visible
      }
      productCategoryId
    }
  }
`;

export const PRODUCT_BY_SLUG = gql`
  query GetProductBySlug($productSlug: String!, $context: RequestContext!) {
    productBySlug(productSlug: $productSlug, context: $context) {
      id
      calendarDisplay
      slug
      name
      protectedByCode
      isBooking
      bookingDays
      exclusionPeriods {
        startDate
        endDate
      }
      consumerCategories {
        ageMax
        ageMin
        name
        shortname
        student
        visible
        position
      }
      additionalInfo {
        shortDescription
      }
      hasDynamicPricing
      includedOptions
      catalog {
        contractor
        selectable
      }
      firstSellableDate
      lastSellableDate
      validityCategory {
        id
        shortname
        visible
      }
      productCategoryId
    }
  }
`;

export const GET_DYNAMIC_PRICES = gql`
  query GetDynamicPrices(
    $productSlug: String!
    $fromDate: String!
    $nbDays: Int!
    $consumerCategoryShortname: String!
    $timeslotsExternalIds: [String!]
    $context: RequestContext!
  ) {
    dynamicPrices(
      productSlug: $productSlug
      fromDate: $fromDate
      nbDays: $nbDays
      consumerCategoryShortname: $consumerCategoryShortname
      timeslotsExternalIds: $timeslotsExternalIds
      context: $context
    ) {
      consumerCategoryShortname
      datesCollection {
        date
        basePrice
        price
        remaining
        timeslotExternalId
      }
    }
  }
`;
